export default __webpack_public_path__ + "static/media/type-correct.39f41de3.png";